<template>
    <div>
        <div class="order-contents">
            <cart-nav
                :options="[ $t('cart_nav.choose_plan'), $t('cart_nav.confirm_details'), $t('cart_nav.complete') ]"
                :active="cartIndex"
                :showTitleInMobile="true"
            />

            <div class="content-wrapper">
                <div class="order-center">
                    <div class="banner-box">
                        <div class="banner-container">
                            <div class="banner" v-if='orderObj.status'>
                                <i class="icon-icon_have have-wrong" v-if='orderObj.status.paymentStatus===paymentStatus.COMPLETED'></i>
                                <i class="icon-icon_wrong have-wrong"  v-if='orderObj.status.paymentStatus===paymentStatus.CLOSED'></i>
                            </div>
                            <div class="banner-text"  v-if='orderObj.status'>
                                <h1 v-if='orderObj.status.paymentStatus === paymentStatus.COMPLETED'>
                                    {{ $t('order_complete.titleComplete') }}
                                </h1>
                                <h1 v-else-if='orderObj.status.paymentStatus===paymentStatus.CREATED'>
                                    {{ $t('order_complete.titleCreated') }}
                                </h1>
                                <h1 v-else-if='orderObj.status.paymentStatus===paymentStatus.CLOSED'>
                                    {{ $t('order_complete.order_status_fail') }}
                                </h1>
                            </div>
                        </div>
                    </div>

                    <div class="mobile-padding" v-if="show">

                        <take-effect-tip
                            v-if='orderObj.status.paymentStatus === paymentStatus.COMPLETED'
                            class='send-email'
                            :plan-type="orderItems.productType"
                        />
                        <p
                            class="send-email"
                            v-if='orderObj.status.paymentStatus === paymentStatus.COMPLETED'
                            v-html="$t(
                                isTraffic ?
                                    'order_complete.traffic.contact_us_success':
                                    'order_complete.contact_us_success',
                                lang,
                                {
                                    link: config.support_team
                                })">
                        </p>
                        <p
                            class="send-email"
                            v-else-if="orderObj.status.currStage === currentStage.PAYMENT
                                && orderObj.status.paymentStatus===paymentStatus.CLOSED && orderObj.closedReason==='paymentDenied'"
                            v-html="$t('order_complete.contact_us_paypalPending')"></p>

                        <p v-else-if='orderObj.status.paymentStatus===paymentStatus.CLOSED'
                            class="send-email"
                            v-html="$t('order_complete.contact_us_fail', lang, {
                                link: config.support_team
                            })"></p>

                        <p class='send-email yellow'  v-if="associateFailedString">
                            {{$t('order_complete.associate_fail',{devices:associateFailedString})}}
                        </p>

                        <p class='send-email yellow'  v-if="unassociateFailedString">
                            {{$t('order_complete.unassociate_fail',{devices:unassociateFailedString})}}
                        </p>

                        <ul class="order-info">
                            <li class="order"><span>&bull; </span>{{$t('order_complete.payment_id')}}<span class="numbers">{{orderObj.id}}</span></li>
                            <li class="order"><span>&bull; </span>{{$t('order_complete.payment_date')}}
                                <span class="numbers">{{timeFormat(timeStr)}}</span>
                            </li>

                            <li class="order"><span>&bull; </span>{{$t('order_complete.payment_status')}}
                                <span class="numbers yellow">
                                    {{$t(`payment_status.${orderObj.status.paymentStatus}`)}}
                                </span>
                            </li>
                            <li class='order' v-if='showPaymentFailReason'><span>&bull; </span>{{$t('order_complete.payment_fail_reason')}}:
                                <span class="numbers yellow">
                                    {{error}}
                                </span>
                            </li>
                            <li v-if='orderObj.status.paymentStatus===paymentStatus.CLOSED && orderObj.closedReason==="expired"' class="order fail-reason">&nbsp;&nbsp;({{$t('order_complete.fail_reason2')}})</li>
                        </ul>
                        <div class="items">
                            <PlanSubscribeCard
                                v-for="(card,index) in planCardItems"
                                :key="index"
                                :plan="card.plan"
                                :startedAt="card.startedAt"
                                :endingAt="card.endingAt"
                                :deviceInfo="card.deviceInfo"
                                :quantity="card.quantity"
                                :adjustmentInfo="adjustmentInfo"
                                :simCard="card.simManager?.data.simCard"
                                :lockDeviceData="card.simManager?.lockedDevice"
                                :showAutoRenew="card.autoRenew !== undefined"
                                :autoRenew="card.autoRenew"
                                mode="show"
                            />
                        </div>
                        <total-box
                            :order="orderObj"
                            class="total"
                            :showAutoRenewal="true"
                        />
                        <div class='user-guide-container' v-if='isTraffic'>
                            <a :href="config.user_guide_traffic" target="_blank" class="ui-link">
                                <span class="text">{{ $t('order_complete.traffic.user_guide') }}</span>
                                <span class="ui-icon icon-icon_arrow-right"></span>
                            </a>
                        </div>
                        <div class="button-box" >
                            <div class="button-box-inner" v-if="config.platform === 'web'">
                                <template v-if="steps[0] === 'end'">
                                    <reo-common-button
                                        @click='goPay()'
                                        v-if="orderObj.status.paymentStatus===paymentStatus.CREATED"
                                        :label="$t('order_complete.tryAgain')"
                                    />
                                    <!-- 如果是云存储套餐 -->
                                    <template v-if='isStoragePlan'>
                                        <!-- 如果绑定了设备，则显示library按钮 -->
                                        <template v-if='orderObj.items[0].context?.associateDevices.length > 0'>
                                            <reo-common-button
                                                :label="$t('cart.finish')"
                                                @click="handleClickLibrary"
                                                :customWidth="finishCustomWidth"
                                            />
                                        </template>
                                        <!-- 否则显示need to bind device按钮 -->
                                        <template v-else>
                                            <div @click="handleNeedToBindDevice">
                                                <reo-common-button v-if="orderObj.status.paymentStatus!==paymentStatus.CREATED"
                                                    :to="`${dashBoardLink}&planId=${orderObj.items[0].productId}`"
                                                    :label="$t('cart.finish')"
                                                    :customWidth="finishCustomWidth"
                                                />
                                            </div>
                                        </template>
                                    </template>
                                    <!-- 否则只显示dashboard按钮 -->
                                    <template v-else>
                                        <reo-common-button v-if="orderObj.status.paymentStatus!==paymentStatus.CREATED"
                                            :to="dashBoardLink"
                                            :label="$t('cart.finish')"
                                            :customWidth="finishCustomWidth"
                                        />
                                    </template>
                                </template>
                                <reo-common-button
                                    @click="nextStep"
                                    v-if="steps.length > 1"
                                    :label="$t('pagination.next')"
                                />
                            </div>
                            <div v-else class="button-box-inner">
                                <reo-common-button
                                    color-type="dark"
                                    customWidth='100%'
                                    :label="$t('cart.finish')"
                                    @click="backToApp"
                                ></reo-common-button>
                            </div>
                        </div>

                    </div>
                    <div class='reo-loading-container' v-else>
                        <processing class="processing"></processing>
                        <h4>{{ $t('payment_processing.title') }}</h4>
                        <p>{{ $t('payment_processing.des') }}</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { getIPlan, getOrderDetailById } from '@/api/cart';
import processing from '@/basic/processing.vue';
import reolinkGa from '@/common/js/gtagPageview';
import { unfoldError } from '@/common/js/notice';
import { unitTransfer } from '@/common/js/utils';
import cartNav from '@/components/cartNav.vue';
import PlanSubscribeCard from '@/components/PlanSubscribeCard.vue';
import { currStage as currentStage, deliver as deliverStatus, payment as paymentStatus } from '@/config/status';
import { timeFormatTraffic } from '@/filter';
import { ECommonButtonType, ESubscribeMode, IOrderItem, IOrder, IPlanCardItem, IAdjustmentInfo, ESimCardModule, ESeriesCategory } from '@reolink-cloud/interface';
import { productsManager, uidHandler } from '@/lib';
import router from '@/router';
import store from '@/store';
import { Async } from '@reolink-web/utils';
import { AxiosError } from 'axios';
import { config } from 'CONFIG';
import nprogress from 'nprogress';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import TotalBox from '@/components/TotalBox/index.vue';
import { SimManager } from '@/lib/simManager';
import { getSimCardList } from '@/api/sim';
import TakeEffectTip from '@/view/complete/components/TakeEffectTip.vue';
import { requestToApp } from '@/api/app';
import { listToString } from '@/api/s3Config';
import { isApp, doorbellProgressStorage } from '@/utils/business';
import { completePendingSubscription } from '@/utils/app';
import { callAppApi } from '@reolink-web/app-sdk';
import { deviceManager } from './lib/deviceManager';
import { formatTime } from '@/common/js/date';
type IPlanCardItemReolink = IPlanCardItem & {
    simManager?: SimManager;
    autoRenew?: boolean;
};

export default Vue.extend({

    components: {

        cartNav,
        processing,
        PlanSubscribeCard,
        TotalBox,
        TakeEffectTip

    },

    data () {

        return {

            config,
            orderObj: {} as IOrder,
            orderItems: {} as IOrderItem,
            timeStr: 0,
            cartIndex: 2,
            paymentStatus,
            currentStage,
            howUnit: '',
            howQue: '',
            salePrice: 0,
            show: false,
            mode: this.$route.query.mode as ESubscribeMode,
            prevPlan: this.$route.query.pp_id,
            error: this.$route.query.error,
            cloudProductLists: {} as Record<string, any>,
            shouldExcludeVAT: false,
            deviceList: [],
            associateSuccess: [] as any[],
            associateFailedString: '',
            unassociateFailedString: '',
            timer: null as null | number,
            e2eeEnabled: true,
            steps: [] as string[],
            planCardItems: [] as IPlanCardItemReolink[],
            ECommonButtonType,
            getOrderDetailCounts: 0
        };

    },

    async created (): Promise<void> {

        // 开启 E2EE FEATURE
        if ( !this.FEATURE( 'main.e2ee' )) {

            await store.dispatch( 'getCMKS' );
            this.e2eeEnabled = Boolean( store.getters.enforcedCMK );

        }
        this.steps.push( 'end' );

        await Promise.all( [
            this.getOrderDetailFun(),
            deviceManager.init()
        ] );
        if ( config.platform === 'web' ) {

            // 根据query string里面的prevPlan和订单内的产品信息，更新reolinkGa组件内的数据，
            // 只有在web需要这个操作
            // 在webview时，是直接从cart页面跳转到此页面，reolinkGa内部状态还没有被销毁
            reolinkGa.subscribeMode = this.mode;
            reolinkGa.prevPlan = this.prevPlan as string;
            reolinkGa.nextPlan = this.orderItems.productId;

        }
        if ( isApp && this.orderItems.productType == ESeriesCategory.CLOUD_DATA_PLAN ) {

            Async.invokeAsync(

                () => callAppApi( 'simCardActivated' )
            );

        }
        // 统计订阅事件
        reolinkGa.sendSubscribeMode();

        nprogress.done();

    },

    methods: {
        handleNeedToBindDevice() {

            reolinkGa.sendSimpleEvent( 'Cloud Storage Service-link device' );

        },
        numberFixed2 ( num ): string {

            return parseFloat( num ).toFixed( 2 );

        },

        timeFormat ( timestamp: number ): string {

            return formatTime( timestamp );

        },

        async getOrderDetailFun (): Promise<void> {

            let orderId = this.$route.query.id;
            try {

                let res: IOrder = {} as IOrder;
                await new Promise(( resolve, reject ) => {

                    const loopGetOrderDetailById = async (): Promise<void> => {

                        try {

                            res = await getOrderDetailById( orderId as string );

                            if ( !( res.status.currStage === currentStage.DELIVER && res.status.deliverStatus === deliverStatus.PENDING )) {

                                resolve( true );

                            } else {

                                this.getOrderDetailCounts++;

                                let time = 1000;

                                if ( this.getOrderDetailCounts > 3 && this.getOrderDetailCounts <= 10 ) {

                                    time = 5000;

                                } else if ( this.getOrderDetailCounts > 10 ) {

                                    time = 10000;

                                }

                                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                                this.timer = window.setTimeout( loopGetOrderDetailById, time );

                            }

                        } catch ( err ) {

                            reject( err );

                        }

                    };

                    // eslint-disable-next-line @typescript-eslint/no-misused-promises
                    this.timer = window.setTimeout( loopGetOrderDetailById, 1000 );

                });
                this.orderObj = res;
                this.orderItems = res.items[0];
                await productsManager.update({ lang: this.lang });
                const planCardItems: IPlanCardItemReolink[] = [];
                const iccidSet = res.items.reduce<Set<string>>(( iccidSet, current ) => {

                    if ( current.context.associateSimCards ) {

                        for ( const simCard of current.context.associateSimCards ) {

                            iccidSet.add( simCard.iccid );

                        }

                    }

                    return iccidSet;

                }, new Set());

                let simManagers: SimManager[] = [];
                //因为批量续费的显示，iccid不会超过一百个
                if ( iccidSet.size > 0 ) {

                    const getSimListRes = await getSimCardList({ iccids: Array.from( iccidSet ), includes: [ESimCardModule.SIM_CARD], limit: 100, page: 1, sortStrategy: 'simCardList' });
                    simManagers = getSimListRes.items.map( item => new SimManager( item, getSimListRes.services ));
                    await Promise.all( simManagers.map( manager => manager.init()));

                }

                for ( const item of res.items ) {

                    const iccid = item.context?.associateSimCards?.[0]?.iccid ?? '';
                    let simManager: SimManager|undefined;
                    if ( iccid !== '' ) {

                        simManager = simManagers.find( manager => manager.iccid === iccid );

                    }
                    const plan = await getIPlan( item.productId, this.lang );
                    planCardItems.push({
                        plan,
                        simManager,
                        startedAt: item.context.trackingInfo?.[0].shippedProduct.duration.start,
                        endingAt: item.context.trackingInfo?.[0].shippedProduct.duration.end,
                        quantity: item.quantity,
                        simCard: item.context.simCard?.iccid,
                        autoRenew: item.context.autoRenew
                    });

                }
                this.planCardItems = planCardItems;
                this.timeStr = res.createdAt;
                this.show = true;

                if ( this.orderObj.taxData.details?.length !== 0 && this.orderObj.taxData.details?.[0].type === 'eu_vat' ) {

                    this.shouldExcludeVAT = this.orderObj.taxData.details[0].valid && !this.orderObj.taxData.details[0].charged;

                }
                if ( res.status.paymentStatus === paymentStatus.COMPLETED ) {

                    let planDetailsInEn = await productsManager.getPlanById( res.items[0].productId );
                    let itemListName = `(cloud-Plan)storageRegion:${this.orderObj.payer.country};`;
                    let name = planDetailsInEn.series?.i18n.name ?? 'unknown';
                    name += `(${planDetailsInEn.duration.amount}-${planDetailsInEn.duration.unit})`;
                    name += `(${planDetailsInEn.style['cloud_storage.video_lifetime'] ?? 0}-days,${planDetailsInEn.style['cloud_storage.max_device_quantity'] ?? 0}-cams,${unitTransfer( planDetailsInEn.style['cloud_storage.space_capacity'] ?? 0 )}${unitTransfer( planDetailsInEn.style['cloud_storage.space_capacity'] ?? 0, 'unit' )})`;
                    let itemCategory = 'cloud-Plan';

                    let eventData = {
                        currency: res.currency,
                        value: Number( res.amount ),
                        transaction_id: res.id,
                        tax: Number( res.taxData.tax ),
                        items: [{
                            item_id: res.items[0].productId,
                            item_name: `(${itemCategory})${name}`,
                            item_category: itemCategory,
                            price: Number( res.items[0].salePrice ),
                            quantity: res.items[0].quantity,
                            item_list_name: itemListName,
                            item_variant: `mode:${this.mode};`
                        }]
                    };
                    reolinkGa.sendECommerceEvent( 'purchase', eventData );

                }
                this.handleAssociatedDevices( res );

            } catch ( err ) {

                console.error( err );
                console.error( 'get order failed' );
                let symbol = ( err as AxiosError ).response?.data.error.symbol;
                if ( symbol === 'order_not_found' ) { // 不是当前用户的订单，跳转到历史页

                    router.push( '/user/cloud-plan-payment-history/' ).catch( console.error );

                }

            }

        },

        async goPay (): Promise<void> {

            try {

                await router.push({

                    path: '/checkout/pay/',
                    query: {
                        o_id: this.orderObj.id,
                        mode: this.orderObj.items[0].context.action,
                        pp_id: this.prevPlan
                    }

                });

            } catch ( err ) {

                let symbol = ( err as AxiosError ).response?.data.error.symbol;
                if ( symbol === 'order_not_acceptable' ) {

                    window.location.reload();

                } else if ( symbol === 'order_expired' ) {

                    unfoldError( 'order_complete.fail_reason2' );

                }

            }

        },
        backToApp() {

            completePendingSubscription( this.orderObj.items[0].context?.subscription );
            requestToApp( 'finishPage', {});

        },
        handleAssociatedDevices( order: IOrder ): void {

            let associateDevices = order.items[0].context?.associateDevices ?? [];
            let unassociateDevices = order.items[0].context?.unassociateDevices ?? [];
            let associateFailed: any[] = [];
            let unassociateFailed: any[] = [];
            let associateSuccess: any[] = [];

            for ( let item of associateDevices ) {

                let uid = item.uid;
                let status = item.status;
                if ( status === 'unassociated' ) {

                    Object.keys( this.deviceList ).map( key => {

                        if ( this.deviceList[key].uid === uid ) {

                            associateFailed.push({
                                uid: uid,
                                title: this.deviceList[key].title || this.deviceList[key].modelTitle
                            });

                        }

                    });

                }
                else if ( status === 'associated' ) {

                    Object.keys( this.deviceList ).map( key => {

                        if ( this.deviceList[key].uid === uid ) {

                            associateSuccess.push({
                                uid: uid,
                                title: this.deviceList[key].title || this.deviceList[key].modelTitle
                            });

                        }

                    });

                }

            }

            for ( let item of unassociateDevices ) {

                let uid = item.uid;
                let status = item.status;
                if ( status === 'associated' ) {

                    Object.keys( this.deviceList ).map( key => {

                        if ( this.deviceList[key].uid === uid ) {

                            unassociateFailed.push({
                                uid: uid,
                                title: this.deviceList[key].title || this.deviceList[key].modelTitle
                            });

                        }

                    });

                }

            }
            this.associateSuccess = associateSuccess;
            this.associateFailedString = listToString( associateFailed.map( item => ( this.$t( 'order_complete.deviceString', { nickName: item.title, uid: item.uid }) as string )), this.$store.state.lang.lang );
            this.unassociateFailedString = listToString( unassociateFailed.map( item => ( this.$t( 'order_complete.deviceString', { nickName: item.title, uid: item.uid }) as string )), this.$store.state.lang.lang );
            const inDoorbellProgress = this.$route.query.inDoorbellProgress;
            if ( typeof inDoorbellProgress === 'string' ) {

                const uid = uidHandler.decrypt( inDoorbellProgress );
                if ( !associateFailed.some( item => item.uid === uid )) {

                    requestToApp( 'completeSubscription', undefined );

                }

            } else {

                const doorbellUid = doorbellProgressStorage.getItem( 'doorbell_progress_uid' ) ?? '';
                if ( doorbellUid ) {

                    if ( !associateFailed.some( item => item.uid === doorbellUid )) {

                        requestToApp( 'completeSubscription', undefined );

                    }
                    doorbellProgressStorage.removeItem( 'doorbell_progress_uid' );

                }

            }

        },
        nextStep (): void {

            this.steps.shift();

        },
        getHref (): string {

            return window.location.href;

        },
        timeFormatTraffic,
        async handleClickLibrary(): Promise<void> {

            reolinkGa.sendSimpleEvent( 'Cloud Storage Service-My Cloud Library' );
            await this.$router.push( '/user/cloud-library/' );

        }

    },

    computed: {
        ...mapGetters( ['isMobile'] as const ),
        totp (): boolean {

            return this.$store.state.user.user.totp;

        },
        isTraffic (): boolean {

            return this.orderItems.productType === 'traffic_plan';

        },
        isStoragePlan(): boolean {

            return this.orderItems.productType === ESeriesCategory.CLOUD_STORAGE_PLAN;

        },
        client (): string {

            return this.config.oem;

        },
        dashBoardLink (): string {

            return `/user/dashboard/?tab=${this.isStoragePlan ? 'cloud' : 'sim'}`;

        },
        lang(): string {

            return this.$store.getters.lang;

        },
        country(): string {

            return this.$store.getters.country;

        },
        currentOrderItem(): IOrderItem|undefined {

            return this.orderObj.items?.[0];

        },
        adjustmentInfo(): IAdjustmentInfo|undefined {

            if ( this.currentOrderItem?.context.adjustment ) {

                return { currency: this.orderObj.currency, amount: parseFloat( this.currentOrderItem.subTotal ) };

            }

            return undefined;

        },
        finishCustomWidth(): number|string {

            return this.isMobile ? '100%' : 200;

        },
        showPaymentFailReason(): boolean {

            return Boolean(
                this.error &&
                this.orderObj.status?.paymentStatus === paymentStatus.CLOSED
            );

        }
    },

    beforeDestroy (): void {

        window.clearInterval( this.timer! );

    }

});
</script>

<style scoped lang="less">
.order-contents {
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 60px;
    @media @snapeak_mobile{
        margin-top: 32px;
        padding: 0 15px;
    }
    /deep/ .wrapper{
        padding: 0;
    }
    .content-wrapper{
        background-color: @bg_02;
        padding: 60px 220px;
        margin-bottom: 60px;
        border-radius: 12px;
        @media @snapeak_mobile{
            background-color: transparent;
            padding: 0;
        }
    }
    .order-center {
        margin-bottom: 70px;
        @media @snapeak_mobile{
            margin-bottom: 15px;
        }
        h1 {
            font-size: 26px;
            line-height: 26px;
            font-weight: bold;
        }

    }
    .mobile-padding {
        padding: 0 0;
        .send-email {
            font-weight: 400;
            margin-top: 21px;
            color: @font_secondary;
            font-size: 16px;
            font-weight: 500;
            @media @snapeak_mobile{
                margin-top: 15px;
            }
            a {
                color: @theme;
                cursor: pointer;
            }
        }
        .items{
            margin-top: 15px;
            display: flex;
            flex-direction: column;
            gap: 10px;
        }
    }
    .order-info {
        margin-top: 20px;
        padding-top: 20px;
        border-top: solid 1px @line;
        border-bottom: solid 1px @line;
        padding-bottom: 28px;
        @media @snapeak_mobile{
            margin-top: 15px;
            padding-bottom: 15px;
            margin-bottom: 15px;
        }
        .fail-reason{
            color:@warning;
        }
        li {
            font-weight: 500;
            font-size: 16px;
            line-height: 16px;
            color: @font_secondary;
            & + li{
                margin-top: 21px;
                @media @snapeak_mobile{
                    margin-top: 5px;
                }
            }
            .numbers {
                color: @font_primary;
                margin-left: 3px;
            }
            .numbers.red{
                color: @brand_red;
            }
        }
    }
    .product {
        margin: 0.3rem 0 0.2rem 0;
        h3 {
            font-weight: 500;
            color: #666666;
            margin-bottom: 0.1rem;
            font-size: 0.16rem;
        }
        section {
            display: flex;
            justify-content: space-between;
            padding-right: 0.3rem;
        .reo-time {
            font-weight: 500;
            color: #333;
            font-size: 0.16rem;
            span {
                font-weight: 400;
                font-size: 0.16rem;
                color: #777777;
            }
        }
        }
    }
    .reo-price {
        color: #333333;
        font-weight: 500;
        font-size: 0.16rem;
        padding-bottom: 0.05rem;
    }
    .period,.valid {
        padding: 0 0.3rem 0.2rem 0;
        display: flex;
        justify-content:space-between;
        h3 {
            font-weight: 400;
            color: #666666;
            font-size: 0.16rem;
        }
        section {
            display: flex;
            justify-content: space-between;
        }
    }
    .total {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        padding-top: 33px;
        padding-bottom: 70px;
        @media @snapeak_mobile{
            padding-bottom: 24px;
            margin-bottom: 0;
            padding-top: 10px;
            margin-top: 15px;
            align-items: stretch;
        }
        section {
            width: 380px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            line-height: normal;
            @media @snapeak_mobile{
                width: auto;
            }
            h3 {
                font-size: 20px;
                font-weight: bold;
                @media @snapeak_mobile{
                    font-size: 16px;
                }
            }
            p {
                font-family: @font_01;
                font-size: 26px;
                font-weight: normal;
                @media @snapeak_mobile{
                    font-size: 22px;
                }
            }

            &.incl-tax {
                margin-top: 4px;
                h3{
                    font-weight: normal;
                }

                p {
                    font-size: 20px;
                    @media @snapeak_mobile{
                        font-size: 16px;
                    }
                }
            }
        }
    }
    .button-box {
        margin-bottom: 1.2rem;
        margin: auto;
        text-align: center;
        .button-box-inner{
            display: inline-flex;
            flex-direction: column;
            gap: 10px;
            @media @snapeak_mobile{
                display: flex;
            }
            a+a{
                margin-top: 0.2rem;
            }
            &>a{
                display: block;
            }

            .e2ee-guide-button {
                display: flex;
                justify-content: center;
                align-items: center;
                line-height: 1.2;
                height: 0.64rem;
                box-sizing: border-box;
                white-space: pre-line;
            }
        }
        .totp-button{
            display: flex !important;
            justify-content: center;
            align-items: center;
            line-height: 1.2;
            height: 0.64rem;
            border-radius: .32rem;
            width: 3.6rem;
            box-sizing: border-box;
            background: #FBB04D;
        }
        .next-step-button {
            width: 3.6rem;
        }
        .ui-button.empty-button{
            line-height: .46rem;
            &:hover{
                line-height: .48rem;
            }
        }
    }
}
.banner-container {
    .banner{
        display: none;
    }
}

.user-guide-container{
    text-align: center;
    margin-bottom: .24rem;
    @media @snapeak_mobile {
        margin-bottom:.32rem;

    }
}

/deep/ .cart-bottom > *{
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
}

.processing{
    margin: 147px 0;
    /deep/ .blinking{
        @media @snapeak_pc{
            background-color: @bg_02;
        }
    }
}

.yellow{
    color: @warning !important
}
</style>
